// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"6fcdb8e8","354":"a37752e1","431":"0d079dff","660":"a8890178","702":"957ff11a","787":"e7436a8b","876":"96fa53cb"}[chunkId] + ".chunk.js";
};